import SortableStoreProductsList from "../react/SortableStoreProductsList";

const setDefaultFilter = ({ sortScope, sortKey }) => {
  $(`${sortScope} .js-sort-table-content[data-title='${sortKey}']`).children(".text-right").children().removeClass("d-none");
};

const visiblityListener = (name) => {
  N2.handle("click", ".js-invisible, .js-visibility", () => {
    $(`.js-${name}-list-completed, .js-visibility, .js-invisible`).toggleClass("hidden");
  });
};

const StoreProductsList = (name) => {
  ["my-store-jobs", "completed"].forEach((ele) => {
    if ($(`.js-${name}-react-data-${ele}`).length) {
      const list = new SortableStoreProductsList({
        sortScope: `#sort-filters-${ele}`,
        selector: `.js-${name}-list-${ele}`,
        data: $(`.js-${name}-react-data-${ele}`).data("jobs"),
        beforeRender: setDefaultFilter,
      });
      list.render();
    }
  });
  visiblityListener(name);
};

export default StoreProductsList;
